import Snackbar from '@mui/material/Snackbar';
import React, { SyntheticEvent } from 'react';
import SnackbarContent from './SnackbarContent';
import { useNotificationContext } from 'contexts/NotificationContext';

export default function ContextSnackbar() {
  const { notification, closeNotification } = useNotificationContext();

  const handleClose = (_event: SyntheticEvent<any>, reason: string) => {
    if (reason === 'clickaway') {
      return;
    }

    closeNotification();
  };

  return (
    <Snackbar
      key={notification.message}
      open={notification.open}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      onClose={handleClose}
      autoHideDuration={notification.durationInMs}
    >
      <div>
        {/* Function component cannot be passed as children to Snackbar
        https://material-ui.com/guides/composition/#caveat-with-refs */}
        <SnackbarContent
          variant={notification.variant}
          message={notification.message}
          onClose={handleClose}
          action={notification.action}
        />
      </div>
    </Snackbar>
  );
}
